module.exports = __webpack_public_path__ + "static/media/mainChart1ForError1.0795da49.png";